import type { RadioFilterProps } from './RadioFilter.types';

const RadioFilter = ({ label, name, options, value, onChange }: RadioFilterProps) => {
  return (
    <div className="types" data-type="radio" data-name={name} data-value={label}>
      <span className="type_name">{label}</span>
      <span className="filter_elements">
        {options.map((option) => (
          <label key={option.value} className="custom-radio">
            <input
              className="el_contents radio-custom"
              type="radio"
              name={name}
              value={option.value}
              data-code={option.code}
              checked={option.value === value}
              onChange={onChange}
            />
            <span className="radio-mark"></span>
            <span className="filtering_text">{option.label}</span>
          </label>
        ))}
      </span>
    </div>
  );
};

export default RadioFilter;
